import src from "IMAGE";
export default { src, width: 1920, height: 1063, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAARklEQVR42m2JywnAMAzFvP8MIdtkly5gg//16y3Qg0BIlJlPVf2CR+5+IuJMON39AUfDIxHZI3vGBRoeMfMyszXxQlUX3gsKOnXg3q+zCQAAAABJRU5ErkJggg=="};
